var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isRoutable && !_vm.collapsible
    ? _c(
        _vm.componentType,
        _vm._b(
          {
            tag: "component",
            attrs: { custom: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({
                    href,
                    route,
                    navigate,
                    isActive,
                    isExactActive,
                  }) {
                    return [
                      _c(
                        "li",
                        {
                          class: [
                            _vm.$style["mds-list-group-item"],
                            _vm.classObject,
                            _vm.activeClass(isActive, isExactActive),
                          ],
                        },
                        [
                          _c(
                            "a",
                            {
                              class: _vm.$style["mds-list-group__link"],
                              attrs: { href: href, tabIndex: _vm.tabIndex },
                              on: { click: navigate },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.$style[
                                      "mds-list-group-item__link-inner"
                                    ],
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        _vm.$style[
                                          "mds-list-group-item__before"
                                        ],
                                        _vm.indentClass,
                                      ],
                                    },
                                    [
                                      _vm.collapsible
                                        ? _c(
                                            "div",
                                            {
                                              class:
                                                _vm.$style[
                                                  "mds-list-group-item__icon-container"
                                                ],
                                            },
                                            [
                                              _c("mds-icon", {
                                                class: [
                                                  _vm.$style[
                                                    "mds-list-group__icon--toggle"
                                                  ],
                                                  _vm.$style[
                                                    "mds-list-group__icon"
                                                  ],
                                                ],
                                                attrs: {
                                                  name: "triangle-fill-right",
                                                  title: "triangle-fill-right",
                                                  size: _vm.iconSize,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.icon
                                        ? _c(
                                            "div",
                                            {
                                              class:
                                                _vm.$style[
                                                  "mds-list-group-item__icon-container"
                                                ],
                                            },
                                            [
                                              _c("mds-icon", {
                                                class:
                                                  _vm.$style[
                                                    "mds-list-group__icon"
                                                  ],
                                                attrs: {
                                                  name: _vm.icon,
                                                  title: _vm.icon,
                                                  size: _vm.iconSize,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.image
                                        ? _c("img", {
                                            class: [
                                              _vm.$style[
                                                "mds-list-group-item__image"
                                              ],
                                              _vm.imageRoundClass,
                                            ],
                                            attrs: {
                                              src: _vm.image,
                                              "aria-hidden": "true",
                                              alt: "",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class:
                                        _vm.$style["mds-list-group-item__main"],
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          class:
                                            _vm.$style[
                                              "mds-list-group-item__upper"
                                            ],
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                _vm.$style[
                                                  "mds-list-group-item__text"
                                                ],
                                            },
                                            [
                                              _vm._t("default", function () {
                                                return [
                                                  _vm._v(_vm._s(_vm.text)),
                                                ]
                                              }),
                                              _vm._v(" "),
                                              _vm.metadata
                                                ? _c("span", {
                                                    class:
                                                      _vm.$style[
                                                        "mds-list-group-item__metadata"
                                                      ],
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.metadata
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm.hasRightSlot
                                            ? _c(
                                                "div",
                                                {
                                                  class:
                                                    _vm.$style[
                                                      "mds-list-group-item__right-slot"
                                                    ],
                                                },
                                                [_vm._t("mds-list-item-right")],
                                                2
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasLowerContent
                                        ? _c(
                                            "div",
                                            {
                                              class:
                                                _vm.$style[
                                                  "mds-list-group-item__lower"
                                                ],
                                            },
                                            [
                                              _vm.hasMicrocopySlot ||
                                              _vm.microcopy
                                                ? _c(
                                                    "div",
                                                    {
                                                      class:
                                                        _vm.$style[
                                                          "mds-list-group-item__microcopy"
                                                        ],
                                                    },
                                                    [
                                                      _vm._t(
                                                        "mds-list-item-microcopy",
                                                        function () {
                                                          return [
                                                            _vm.microcopy
                                                              ? _c("span", {
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        _vm.microcopy
                                                                      ),
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.metadataBelow &&
                                              _vm.metadataBelow.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      class:
                                                        _vm.$style[
                                                          "mds-list-group-item__metadata-below"
                                                        ],
                                                    },
                                                    _vm._l(
                                                      _vm.metadataBelow,
                                                      function (item, index) {
                                                        return _c("span", {
                                                          key: `metabelow-${index}`,
                                                          class:
                                                            _vm.$style[
                                                              "mds-list-group-item__metadata-below-item"
                                                            ],
                                                          domProps: {
                                                            innerHTML:
                                                              _vm._s(item),
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hasChildrenSlot &&
                          (_vm.expanded || !_vm.collapsible)
                            ? _c(
                                "mds-list-group",
                                {
                                  class: _vm.$style["mds-list-group--child"],
                                  attrs: {
                                    id: _vm.ariaControls,
                                    size: _vm.parentVariation.size,
                                  },
                                },
                                [_vm._t("mds-list-item-children")],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          },
          "component",
          _vm.routingProps,
          false
        )
      )
    : _c(
        "li",
        { class: [_vm.$style["mds-list-group-item"], _vm.classObject] },
        [
          _c(
            _vm.componentType,
            {
              tag: "component",
              class: _vm.$style["mds-list-group__link"],
              attrs: {
                href: _vm.href,
                "aria-disabled": _vm.disabled,
                tabindex: _vm.tabIndex,
                "aria-expanded": _vm.ariaExpanded,
                "aria-controls": _vm.ariaControls,
                role: _vm.role,
              },
            },
            [
              _c(
                "div",
                { class: _vm.$style["mds-list-group-item__link-inner"] },
                [
                  _c(
                    "div",
                    {
                      class: [
                        _vm.$style["mds-list-group-item__before"],
                        _vm.indentClass,
                      ],
                    },
                    [
                      _vm.collapsible
                        ? _c(
                            "div",
                            {
                              class:
                                _vm.$style[
                                  "mds-list-group-item__icon-container"
                                ],
                            },
                            [
                              _c("mds-icon", {
                                class: [
                                  _vm.$style["mds-list-group__icon--toggle"],
                                  _vm.$style["mds-list-group__icon"],
                                ],
                                attrs: {
                                  name: "triangle-fill-right",
                                  title: "triangle-fill-right",
                                  size: _vm.iconSize,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.icon
                        ? _c(
                            "div",
                            {
                              class:
                                _vm.$style[
                                  "mds-list-group-item__icon-container"
                                ],
                            },
                            [
                              _c("mds-icon", {
                                class: _vm.$style["mds-list-group__icon"],
                                attrs: {
                                  name: _vm.icon,
                                  title: _vm.icon,
                                  size: _vm.iconSize,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.image
                        ? _c("img", {
                            class: [
                              _vm.$style["mds-list-group-item__image"],
                              _vm.imageRoundClass,
                            ],
                            attrs: {
                              src: _vm.image,
                              "aria-hidden": "true",
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.$style["mds-list-group-item__main"] },
                    [
                      _c(
                        "div",
                        { class: _vm.$style["mds-list-group-item__upper"] },
                        [
                          _c(
                            "span",
                            { class: _vm.$style["mds-list-group-item__text"] },
                            [
                              _vm._t("default", function () {
                                return [_vm._v(_vm._s(_vm.text))]
                              }),
                              _vm._v(" "),
                              _vm.metadata
                                ? _c("span", {
                                    class:
                                      _vm.$style[
                                        "mds-list-group-item__metadata"
                                      ],
                                    domProps: {
                                      innerHTML: _vm._s(_vm.metadata),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.hasRightSlot
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.$style[
                                      "mds-list-group-item__right-slot"
                                    ],
                                },
                                [_vm._t("mds-list-item-right")],
                                2
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.hasLowerContent
                        ? _c(
                            "div",
                            { class: _vm.$style["mds-list-group-item__lower"] },
                            [
                              _vm.hasMicrocopySlot || _vm.microcopy
                                ? _c(
                                    "div",
                                    {
                                      class:
                                        _vm.$style[
                                          "mds-list-group-item__microcopy"
                                        ],
                                    },
                                    [
                                      _vm._t(
                                        "mds-list-item-microcopy",
                                        function () {
                                          return [
                                            _vm.microcopy
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.microcopy
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.metadataBelow && _vm.metadataBelow.length
                                ? _c(
                                    "div",
                                    {
                                      class:
                                        _vm.$style[
                                          "mds-list-group-item__metadata-below"
                                        ],
                                    },
                                    _vm._l(
                                      _vm.metadataBelow,
                                      function (item, index) {
                                        return _c("span", {
                                          key: `metabelow-${index}`,
                                          class:
                                            _vm.$style[
                                              "mds-list-group-item__metadata-below-item"
                                            ],
                                          domProps: { innerHTML: _vm._s(item) },
                                        })
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.hasChildrenSlot && (_vm.expanded || !_vm.collapsible)
            ? _c(
                "mds-list-group",
                {
                  class: _vm.$style["mds-list-group--child"],
                  attrs: {
                    id: _vm.ariaControls,
                    size: _vm.parentVariation.size,
                  },
                },
                [_vm._t("mds-list-item-children")],
                2
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }